import React, { useState } from 'react';
import { message, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { formValidation } from '../../utils/FormValidation';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../redux/features/auth/authActions';
import { persistor } from '../../redux/store';

function ResetPassword() {
    const [email, setEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { loading } = useSelector((state) => state.auth);

    const handleResetPassword = async (e) => {
        e.preventDefault();

        const errors = formValidation(email, newPassword);   // Validate form
        if (Object.keys(errors).length > 0) {
            if (errors.email) {
                message.error(errors.email);
            }
            if (errors.password) {
                message.error(errors.password);
            }
            return;
        }


        try {
            await dispatch(resetPassword({ email, verificationCode, newPassword })).unwrap();
            persistor.purge();
            navigate('/login')   // Navigate to login page       
        } catch (err) {
            const errorMessage = err.error || 'Reset code send failed';
            message.error(errorMessage);
        }

    };

    return (
        <section className="bg-background-primary-color">
            <Spin spinning={loading} fullscreen />
            <div className="flex flex-col items-center justify-center  px-1 py-8 mx-auto md:h-screen lg:py-0">
                <a href="#" className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
                    <img src="/img/logo.png" className='w-[220px]' alt="Logo" />
                </a>
                <div className="w-full bg-gray-800  rounded-lg  md:mt-0 sm:max-w-md xl:p-0 ">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 className="text-xl font-poppins font-bold leading-tight tracking-tight md:text-2xl text-gray-200">
                            Reset Password
                        </h1>
                        <form onSubmit={handleResetPassword} className="space-y-4 md:space-y-6">
                            <div>
                                <label htmlFor="email" className="block mb-2 font-poppins text-sm font-medium text-gray-200">Your email</label>
                                <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@example.com" required />
                            </div>
                            <div>
                                <label htmlFor="code" className="block mb-2 font-poppins text-sm font-medium text-gray-200">Verification Code</label>
                                <input type="text" name="code" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Enter the code" required />
                            </div>
                            <div>
                                <label htmlFor="newPassword" className="block mb-2 font-poppins text-sm font-medium text-gray-200">New Password</label>
                                <input type="text" name="newPassword" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="••••••••" required />
                            </div>
                            <button type="submit" className="w-full text-gray-900 bg-btn-color transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">Reset Password</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ResetPassword;
